<template>
  <div
    v-if="show"
    class="aj-loader"
    :class="classObject"
  >
    <div class="aj-loader__spinner" />
    <aj-text
      v-if="header"
      class="aj-loader__header"
      body-medium
    >
      {{ header }}
    </aj-text>
    <aj-text
      v-if="description"
      class="aj-loader__description"
    >
      {{ description }}
    </aj-text>
  </div>
</template>

<script>
import AjText from '../AjText/AjText.vue';

export default {
  name: 'AjLoader',

  components: { AjText },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    fullSize: {
      type: Boolean,
      default: false,
    },
    invert: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    big: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classObject () {
      return {
        '-full-size': this.fullSize,
        '-invert': this.invert,
        '-transparent': this.transparent,
        '-small': this.small,
        '-big': this.big,
      };
    },
  },
};
</script>

<style lang="scss" src="./AjLoader.scss" scoped />
